// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { AccessibilityFastTrackRepoService } from '@client/app/services/api/accessibility/accessibility-fast-track-repo/accessibility-fast-track-repo.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'fast-track-dialogs-pages',
    templateUrl: './fast-track-pages.html',
    standalone: false,
})
export class FastTrackDialogsPagesComponent extends BaseContainerComponentController implements OnInit {
    @Input() accessibilitySourceCodeId!: string;
    @Input() check!: any;

    viewsColumIsAvailable!: boolean;
    pageDetailsIsAvailable!: boolean;
    pages: any = [];
    tabs: any[] = [];
    progress: Promise<any> | null = null;

    constructor (
        private accessibilityFastTrackRepo: AccessibilityFastTrackRepoService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, pages: true });
    }

    ngOnInit (): void {
        this.init();
    }

    init (): void {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.search = '';
        this.currentSort = { by: 'hits', direction: 'desc' };
        this.tabs = [];
        this.getPage();
        this.getLabels();
    }

    override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search || undefined,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        this.progress = this.accessibilityFastTrackRepo.getAllPages(this.accessibilitySourceCodeId, this.check.id, params).then(
            (data) => {
                this.pages = data;
                return data;
            },
        ).catch(() => {
            // Handle error silently
        });
    }
}
